var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.results !== null)?_c('div',[(_vm.results.length > 0)?_c('div',[_c('div',{ref:"hearingTraningLevel",staticClass:"chart",attrs:{"id":"hearingTraningLevel"}})]):_c('div',{staticClass:"w-100 text-center pt-3"},[_c('p',{staticClass:"is-bold"},[_vm._v("Sem Resultados")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }